import React from 'react';
import _ from 'lodash';
import {connectDynamic, DynamicComponent} from 'go/components/dynamic/dynamicComponent';

export class CommitmentListener extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidUpdate(prevProps) {
    const { commitmentNumbers, commitmentLineNumber } = prevProps;
    if (
       commitmentNumbers != this.props.commitmentNumbers &&
       commitmentLineNumber != this.props.commitmentLineNumber &&
       this.props.commitmentNumbers != undefined &&
      _.get(this.props,'commitmentNumbers.0') !== this.props.commitmentNumberSaved
    ) {
      this.props.saveEntityData(
        'context.awardRecommendation.payload.commitment.commitmentNumberId',
        'awardRecommendation',
        _.get(this.props,'commitmentNumbers.0')
      );
      this.props.saveEntityData(
        'context.awardRecommendation.payload.commitment.commitmentLineNumber',
        'awardRecommendation',
        this.props.commitmentLineNumber
      );
    }
  }

  render() {
    return null;
  }
}
export default connectDynamic(CommitmentListener);
